export default __webpack_public_path__ + "static/media/profile_image.a4e2d264.png";